import { v } from '../validation'

// exported here for reuse in multiple places, and to enable changing the validation library in the future

const digitsOrEmptyStringRegex = /^\d*$/

export const matterDetailsSchema = v.object({
  dateOpened: v.date().required().label('Date opened'),
  description: v.string().max(255).required().label('Matter description'),
  prospect: v.boolean().label('Prospect'),
  worktype: v.object().required().label('Worktype'),
  branch: v.object().required().label('Branch'),
  department: v.object().required().label('Department')
})

export const accountControlSchema = v.object({
  wipLimit: v.string().matches(digitsOrEmptyStringRegex, 'Must be a number').label('WIP limit'),
  debtorLimit: v.string().matches(digitsOrEmptyStringRegex, 'Must be a number').label('Debtor limit'),
  disbursementsLimit: v.string().matches(digitsOrEmptyStringRegex, 'Must be a number').label('Disbursements limit')
})

export const matterFundingSchema = v.object({
  privateOrLegalAid: v.string().label('Private or Legal Aid'),
  remunerationType: v.object().label('Remuneration type').nullable()
})
